module.exports = __webpack_public_path__ + "img/entry.f25a8437.svg";